// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useParams, useOutletContext } from "react-router-dom";
// import HeaderOne from "../../../HeaderOne";
// import FooterOne from "../../../FooterOne";

// const API_URL = process.env.REACT_APP_API_URL;

// const Invoice = () => {
//   const { orderId } = useParams();
//   const outletContext = useOutletContext();
//   const [order, setOrder] = useState(outletContext?.order || null);
//   const [loading, setLoading] = useState(!outletContext?.order);

//   const fetchOrder = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_URL}/order/${orderId}`);
//       setOrder(res.data.data);
//     } catch (err) {
//       console.error("Invoice Fetch Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!order) {
//       fetchOrder();
//     }
//   }, [orderId]);

//   const handlePrint = () => {
//     window.print();
//   };

//   if (loading) {
//     return (
//       <>
//         <style>{`
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }
//         `}</style>
//         <div style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: '300px',
//           gap: '1rem'
//         }}>
//           <div style={{
//             width: '40px',
//             height: '40px',
//             border: '4px solid #e5e7eb',
//             borderTopColor: '#111827',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite'
//           }}></div>
//           <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Loading invoice...</p>
//         </div>
//       </>
//     );
//   }

//   if (!order) {
//     return (
//       <div style={{
//         textAlign: 'center',
//         padding: '3rem 1rem',
//         color: '#6b7280'
//       }}>
//         <p>Unable to load invoice data</p>
//       </div>
//     );
//   }

//   const subtotal = order.items.reduce((sum, item) => sum + (item.price * item.qty), 0);

//   return (
//     <>
//     <HeaderOne/>
//       <style>{`
//         @media print {
//           body * {
//             visibility: hidden;
//           }
//           .invoice-wrapper, .invoice-wrapper * {
//             visibility: visible;
//           }
//           .invoice-wrapper {
//             position: absolute;
//             left: 0;
//             top: 0;
//             width: 100%;
//             padding: 20px;
//           }
//           .print-btn, .no-print {
//             display: none !important;
//           }
//           .invoice-wrapper {
//             box-shadow: none !important;
//             border: none !important;
//           }
//         }

//         .invoice-wrapper {
//           background: white;
//           max-width: 900px;
//           margin: 0 auto;
//           padding: 2rem;
//           border-radius: 8px;
//           border: 1px solid #e5e7eb;
//         }

//         .invoice-header {
//           text-align: center;
//           padding-bottom: 1.5rem;
//           margin-bottom: 1.5rem;
//           border-bottom: 2px solid #111827;
//         }

//         .invoice-title {
//           font-size: 2rem;
//           font-weight: 700;
//           color: #111827;
//           margin: 0 0 1rem 0;
//           letter-spacing: 2px;
//         }

//         .invoice-meta {
//           display: flex;
//           justify-content: center;
//           gap: 2rem;
//           flex-wrap: wrap;
//           margin-bottom: 1rem;
//         }

//         .invoice-meta p {
//           font-size: 0.875rem;
//           color: #6b7280;
//           margin: 0;
//         }

//         .invoice-meta strong {
//           color: #111827;
//           font-weight: 500;
//         }

//         .print-btn {
//           padding: 0.625rem 1.5rem;
//           background: #111827;
//           color: white;
//           border: none;
//           border-radius: 6px;
//           font-weight: 500;
//           font-size: 0.875rem;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           margin-top: 1rem;
//         }

//         .print-btn:hover {
//           background: #374151;
//         }

//         .invoice-addresses {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 1.5rem;
//           margin-bottom: 2rem;
//         }

//         .address-block {
//           padding: 1.25rem;
//           background: #fafafa;
//           border-radius: 6px;
//           border: 1px solid #e5e7eb;
//         }

//         .address-block h3 {
//           font-size: 0.875rem;
//           font-weight: 600;
//           color: #111827;
//           margin: 0 0 0.75rem 0;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         .address-block p {
//           font-size: 0.875rem;
//           color: #6b7280;
//           margin: 0 0 0.375rem 0;
//           line-height: 1.5;
//         }

//         .address-block p strong {
//           color: #111827;
//           font-weight: 500;
//         }

//         .invoice-table-wrapper {
//           overflow-x: auto;
//           margin-bottom: 2rem;
//         }

//         .invoice-table {
//           width: 100%;
//           border-collapse: collapse;
//           font-size: 0.875rem;
//         }

//         .invoice-table thead {
//           background: #111827;
//           color: white;
//         }

//         .invoice-table th {
//           padding: 0.75rem 1rem;
//           text-align: left;
//           font-weight: 500;
//           font-size: 0.8125rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         .invoice-table th:last-child,
//         .invoice-table td:last-child {
//           text-align: right;
//         }

//         .invoice-table th:first-child {
//           width: 50px;
//         }

//         .invoice-table tbody tr {
//           border-bottom: 1px solid #e5e7eb;
//         }

//         .invoice-table tbody tr:hover {
//           background: #fafafa;
//         }

//         .invoice-table td {
//           padding: 0.875rem 1rem;
//           color: #374151;
//         }

//         .invoice-table td:first-child {
//           color: #6b7280;
//           font-weight: 500;
//         }

//         .invoice-summary {
//           max-width: 400px;
//           margin-left: auto;
//           margin-bottom: 2rem;
//         }

//         .summary-row {
//           display: flex;
//           justify-content: space-between;
//           padding: 0.5rem 0;
//           font-size: 0.875rem;
//           color: #6b7280;
//         }

//         .summary-row.total {
//           padding-top: 1rem;
//           margin-top: 0.5rem;
//           border-top: 2px solid #111827;
//           font-size: 1.125rem;
//           font-weight: 600;
//           color: #111827;
//         }

//         .invoice-footer {
//           text-align: center;
//           padding-top: 2rem;
//           border-top: 1px solid #e5e7eb;
//         }

//         .invoice-footer p {
//           font-size: 1rem;
//           color: #111827;
//           margin: 0 0 0.5rem 0;
//           font-weight: 500;
//         }

//         .invoice-footer small {
//           font-size: 0.75rem;
//           color: #9ca3af;
//         }

//         @media (max-width: 768px) {
//           .invoice-wrapper {
//             padding: 1.5rem 1rem;
//           }

//           .invoice-title {
//             font-size: 1.5rem;
//           }

//           .invoice-meta {
//             flex-direction: column;
//             gap: 0.5rem;
//             align-items: center;
//           }

//           .invoice-addresses {
//             grid-template-columns: 1fr;
//             gap: 1rem;
//           }

//           .address-block {
//             padding: 1rem;
//           }

//           .invoice-table th,
//           .invoice-table td {
//             padding: 0.625rem 0.5rem;
//             font-size: 0.8125rem;
//           }

//           .invoice-summary {
//             max-width: 100%;
//           }
//         }

//         @media (max-width: 480px) {
//           .invoice-wrapper {
//             padding: 1rem 0.75rem;
//           }

//           .invoice-title {
//             font-size: 1.25rem;
//             letter-spacing: 1px;
//           }

//           .invoice-table th:nth-child(4),
//           .invoice-table td:nth-child(4) {
//             display: none;
//           }
//         }
//       `}</style>

//       <div className="invoice-wrapper">
//         {/* Header */}
//         <div className="invoice-header">
//           <h1 className="invoice-title">INVOICE</h1>
//           <div className="invoice-meta">
//             <p>Order ID: <strong>#{order._id.slice(-8).toUpperCase()}</strong></p>
//             <p>Date: <strong>{new Date(order.createdAt).toLocaleDateString('en-IN', {
//               day: 'numeric',
//               month: 'long',
//               year: 'numeric'
//             })}</strong></p>
//             <p>Status: <strong style={{ 
//               textTransform: 'capitalize',
//               color: order.status === 'delivered' ? '#10b981' : '#f59e0b'
//             }}>{order.status}</strong></p>
//           </div>
//           <button className="print-btn no-print" onClick={handlePrint}>
//             🖨️ Print Invoice
//           </button>
//         </div>

//         {/* Addresses */}
//         <div className="invoice-addresses">
//           <div className="address-block">
//             <h3>Billing Address</h3>
//             <p><strong>{order.billing.firstName} {order.billing.lastName}</strong></p>
//             <p>{order.billing.address1}</p>
//             {order.billing.address2 && <p>{order.billing.address2}</p>}
//             <p>{order.billing.city}, {order.billing.state} - {order.billing.pincode}</p>
//             <p>Phone: {order.billing.phone}</p>
//             {order.billing.email && <p>Email: {order.billing.email}</p>}
//           </div>

//           <div className="address-block">
//             <h3>Shipping Address</h3>
//             <p><strong>{order.shipping.firstName} {order.shipping.lastName}</strong></p>
//             <p>{order.shipping.address1}</p>
//             {order.shipping.address2 && <p>{order.shipping.address2}</p>}
//             <p>{order.shipping.city}, {order.shipping.state} - {order.shipping.pincode}</p>
//             <p>Phone: {order.shipping.phone}</p>
//           </div>

//           <div className="address-block">
//             <h3>Payment Details</h3>
//             <p>Method: <strong>{order.paymentMethod.toUpperCase()}</strong></p>
//             <p>Payment Status: <strong style={{ 
//               textTransform: 'capitalize',
//               color: order.status === 'delivered' ? '#10b981' : '#f59e0b'
//             }}>{order.status}</strong></p>
//           </div>
//         </div>

//         {/* Items Table */}
//         <div className="invoice-table-wrapper">
//           <table className="invoice-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Item Name</th>
//                 <th>Qty</th>
//                 <th>Price</th>
//                 <th>Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               {order.items.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.name}</td>
//                   <td>{item.qty}</td>
//                   <td>{item.price.toFixed(2)}</td>
//                   <td>{(item.price * item.qty).toFixed(2)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Summary */}
//         <div className="invoice-summary">
//           <div className="summary-row">
//             <span>Subtotal:</span>
//             <span>{subtotal.toFixed(2)}</span>
//           </div>
//           <div className="summary-row">
//             <span>Tax:</span>
//             <span>{(order.tax || 0).toFixed(2)}</span>
//           </div>
//           <div className="summary-row">
//             <span>Delivery Charges:</span>
//             <span>{(order.delivery || 0).toFixed(2)}</span>
//           </div>
//           <div className="summary-row total">
//             <span>Grand Total:</span>
//             <span>{order.totalAmount.toFixed(2)}</span>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="invoice-footer">
//           <p>Thank you for shopping with us!</p>
//           <small>This is a computer-generated invoice. No signature required.</small>
//         </div>
//       </div>
//       <FooterOne/>
//     </>
//   );
// };

// export default Invoice;

import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import HeaderOne from "../../../HeaderOne";
import FooterOne from "../../../FooterOne";

const API_URL = process.env.REACT_APP_API_URL;

/* ── helpers ─────────────────────────────────────────────────── */
const fmt = (n = 0) =>
  Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : "";

/* ── component ───────────────────────────────────────────────── */
const Invoice = () => {
  const { orderId }    = useParams();
  const outletContext  = useOutletContext();
  const [order, setOrder]     = useState(outletContext?.order || null);
  const [loading, setLoading] = useState(!outletContext?.order);

  useEffect(() => {
    if (!order) {
      setLoading(true);
      axios
        .get(`${API_URL}/order/${orderId}`)
        .then((res) => setOrder(res.data.data))
        .catch((err) => console.error("Invoice Fetch Error:", err))
        .finally(() => setLoading(false));
    }
  }, [orderId]);

  if (loading) {
    return (
      <>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center",
          justifyContent:"center", minHeight:300, gap:16 }}>
          <div style={{ width:40, height:40, border:"4px solid #e5e7eb",
            borderTopColor:"#111827", borderRadius:"50%",
            animation:"spin 1s linear infinite" }} />
          <p style={{ color:"#6b7280", fontSize:14 }}>Loading invoice…</p>
        </div>
      </>
    );
  }

  if (!order) {
    return (
      <div style={{ textAlign:"center", padding:"3rem 1rem", color:"#6b7280" }}>
        <p>Unable to load invoice data.</p>
      </div>
    );
  }

  /* ── destructure ── */
  const {
    _id,
    createdAt,
    shipping,
    items       = [],
    shiprocket  = {},
    paymentMethod,
    totalAmount,
    tax         = 0,
    delivery    = 0,
    status,
  } = order;

  const vendor       = items[0]?.vendorId ?? {};
  const orderDate    = fmtDate(createdAt);
  const invoiceNo    = shiprocket.invoice_no || `Retail${_id.slice(-5).toUpperCase()}`;
  const awb          = shiprocket.awb_code    || "—";
  const courier      = shiprocket.courier_name || "—";
  const channelId    = shiprocket.channel_id;
  const stateCode    = shipping.pincode ? shipping.pincode.slice(0, 2) : "23";
  const netTotal     = items.reduce((s, i) => s + i.price * i.qty, 0);

  /* 10 table columns → need correct colSpan math */
  const TOTAL_COLS = 10;

  return (
    <>
      <HeaderOne />

      <style>{`
        @media print {
          body * { visibility: hidden; }
          .inv-root, .inv-root * { visibility: visible; }
          .inv-root { position: absolute; left: 0; top: 0; width: 100%; padding: 20px; }
          .no-print { display: none !important; }
        }

        /* ── wrapper ── */
        .inv-root {
          font-family: Arial, Helvetica, sans-serif;
          font-size: 12px;
          color: #1a1a1a;
          max-width: 900px;
          margin: 32px auto 48px;
          padding: 32px;
          background: #fff;
          border: 1px solid #d1d5db;
          border-radius: 4px;
        }

        /* ── logo ── */
        .inv-logo { text-align: center; margin-bottom: 10px; }
        .inv-logo img { height: 68px; object-fit: contain; }

        /* ── title ── */
        .inv-title {
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          letter-spacing: 5px;
          border-top: 2.5px solid #111;
          border-bottom: 2.5px solid #111;
          padding: 7px 0;
          margin-bottom: 18px;
        }

        /* ── three-col info grid ── */
        .inv-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          border: 1px solid #bbb;
          margin-bottom: 20px;
        }
        .inv-col {
          padding: 10px 12px;
          border-right: 1px solid #bbb;
          font-size: 12px;
          line-height: 1.65;
          vertical-align: top;
        }
        .inv-col:last-child { border-right: none; }
        .inv-col-title {
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          border-bottom: 1px solid #bbb;
          padding-bottom: 5px;
          margin-bottom: 7px;
        }

        /* sold-by column centered like PDF */
        .inv-col-center { text-align: center; }
        .inv-col-center .inv-col-title { text-align: left; }

        /* key-value rows in invoice details column */
        .inv-kv {
          display: grid;
          grid-template-columns: 115px 1fr;
          gap: 2px;
          margin-bottom: 1px;
          font-size: 11.5px;
        }
        .inv-kv-k { font-weight: 700; }
        .inv-kv-v { word-break: break-word; }

        /* ── items table ── */
        .inv-tbl-wrap { overflow-x: auto; margin-bottom: 14px; }
        .inv-tbl {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
          min-width: 760px;
        }

        /* header */
        .inv-tbl thead tr th {
          background: #f1f1f1;
          border: 1px solid #bbb;
          padding: 6px 6px;
          font-weight: 700;
          font-size: 10.5px;
          text-align: center;
          text-transform: uppercase;
          letter-spacing: 0.2px;
          white-space: nowrap;
        }
        .inv-tbl thead tr th.th-left { text-align: left; }

        /* body cells */
        .inv-tbl tbody td {
          border: 1px solid #bbb;
          padding: 7px 6px;
          vertical-align: middle;
          font-size: 11px;
        }
        .inv-tbl tbody td.td-center { text-align: center; }
        .inv-tbl tbody td.td-right  { text-align: right;  }

        /* product name + sku inside cell */
        .inv-pname { font-weight: 600; line-height: 1.4; }
        .inv-psku  { font-size: 9.5px; color: #666; margin-top: 3px; }

        /* net total row */
        .inv-net td {
          background: #f5f5f5;
          border: 1px solid #bbb;
          font-weight: 700;
          font-size: 13px;
          padding: 8px 6px;
        }

        /* footer note */
        .inv-note {
          font-size: 12px;
          margin-top: 12px;
          color: #333;
        }

        /* print btn */
        .inv-print {
          display: block;
          margin: 0 auto 20px;
          padding: 10px 32px;
          background: #111827;
          color: #fff;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          letter-spacing: 0.4px;
        }
        .inv-print:hover { background: #374151; }

        /* responsive */
        @media (max-width: 680px) {
          .inv-root { padding: 14px; margin: 8px; }
          .inv-grid { grid-template-columns: 1fr; }
          .inv-col  { border-right: none; border-bottom: 1px solid #bbb; }
          .inv-col:last-child { border-bottom: none; }
        }
      `}</style>

      <div className="inv-root">

        {/* print button */}
        <button className="inv-print no-print" onClick={() => window.print()}>
          🖨️ Print Invoice
        </button>

        {/* logo */}
        <div className="inv-logo">
          <img
            src="/assets/img/brand-logos/MordenBazaar-04.png"
            alt="MordenBazaar"
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>

        {/* title */}
        <div className="inv-title">TAX INVOICE</div>

        {/* ── info grid ── */}
        <div className="inv-grid">

          {/* Col 1 — Shipping Address */}
          <div className="inv-col">
            <div className="inv-col-title">Shipping Address:</div>
            <div style={{ fontWeight: 600 }}>
              {shipping.firstName?.trim()} {shipping.lastName?.trim()}
            </div>
            <div>{shipping.address1}</div>
            {shipping.address2?.trim() && <div>{shipping.address2.trim()}</div>}
            <div>{shipping.city} {shipping.pincode}</div>
            <div>{shipping.state}</div>
            <div>{shipping.country}</div>
            <div>State Code : {stateCode}</div>
          </div>

          {/* Col 2 — Sold By */}
          <div className="inv-col inv-col-center">
            <div className="inv-col-title">Sold By:</div>
            {vendor.businessName && (
              <div style={{ fontWeight: 600 }}>{vendor.businessName}</div>
            )}
            {vendor.shopAddress && <div>{vendor.shopAddress}</div>}
            {vendor.city        && <div>{vendor.city} {vendor.pincode || ""}</div>}
            {vendor.state       && <div>{vendor.state}</div>}
            <div>India</div>
            <div>State Code : 23</div>
            {vendor.phone       && <div>Ph: {vendor.phone}</div>}
            {vendor.gstNumber   && <div>GSTIN No. {vendor.gstNumber}</div>}
            <div>Website: https://www.mordenbazaar.com/</div>
            {vendor.email       && <div>Email: {vendor.email}</div>}
          </div>

          {/* Col 3 — Invoice Details */}
          <div className="inv-col">
            <div className="inv-col-title">Invoice Details:</div>
            <div className="inv-kv">
              <span className="inv-kv-k">INVOICE NO.</span>
              <span className="inv-kv-v">: {invoiceNo}</span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">INVOICE DATE</span>
              <span className="inv-kv-v">: {orderDate}</span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">ORDER NO.</span>
              <span className="inv-kv-v" style={{ fontSize: 10, wordBreak: "break-all" }}>
                : {_id}
              </span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">ORDER DATE</span>
              <span className="inv-kv-v">: {orderDate}</span>
            </div>
            {channelId && (
              <div className="inv-kv">
                <span className="inv-kv-k">CHANNEL</span>
                <span className="inv-kv-v">: CUSTOM ({channelId})</span>
              </div>
            )}
            <div className="inv-kv">
              <span className="inv-kv-k">SHIPPED BY</span>
              <span className="inv-kv-v">: {courier}</span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">AWB NO.</span>
              <span className="inv-kv-v">: {awb}</span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">PAYMENT METHOD</span>
              <span className="inv-kv-v">: {paymentMethod}</span>
            </div>
            <div className="inv-kv">
              <span className="inv-kv-k">ORDER STATUS</span>
              <span className="inv-kv-v">: {status}</span>
            </div>
          </div>

        </div>

        {/* ── items table ── */}
        <div className="inv-tbl-wrap">
          <table className="inv-tbl">
            <colgroup>
              <col style={{ width: "4%" }}  />  {/* S.NO */}
              <col style={{ width: "26%" }} />  {/* PRODUCT NAME */}
              <col style={{ width: "6%" }}  />  {/* HSN */}
              <col style={{ width: "4%" }}  />  {/* QTY */}
              <col style={{ width: "9%" }}  />  {/* UNIT PRICE */}
              <col style={{ width: "9%" }}  />  {/* UNIT DISCOUNT */}
              <col style={{ width: "10%" }} />  {/* TAXABLE VALUE */}
              <col style={{ width: "11%" }} />  {/* CGST */}
              <col style={{ width: "11%" }} />  {/* SGST */}
              <col style={{ width: "10%" }} />  {/* TOTAL */}
            </colgroup>

            <thead>
              <tr>
                <th>S.NO.</th>
                <th className="th-left">PRODUCT NAME</th>
                <th>HSN</th>
                <th>QTY</th>
                <th>UNIT<br/>PRICE</th>
                <th>UNIT<br/>DISCOUNT</th>
                <th>TAXABLE<br/>VALUE</th>
                <th>CGST<br/>(Value | %)</th>
                <th>SGST<br/>(Value | %)</th>
                <th>TOTAL<br/>(Incl. GST)</th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, i) => {
                const lineTotal    = item.total ?? item.price * item.qty;
                const taxableValue = item.price * item.qty;
                const cgst         = item.cgst    ?? 0;
                const sgst         = item.sgst    ?? 0;
                const cgstPct      = item.cgstPct ?? 0;
                const sgstPct      = item.sgstPct ?? 0;
                const sku          = `SKU_${_id}`;

                return (
                  <tr key={item._id ?? i}>
                    <td className="td-center">{i + 1}</td>

                    {/* Product name + SKU */}
                    <td>
                      <div className="inv-pname">{item.name}</div>
                      <div className="inv-psku">SKU : {sku}</div>
                    </td>

                    <td className="td-center">{item.hsn || ""}</td>
                    <td className="td-center">{item.qty}</td>
                    <td className="td-right">Rs. {fmt(item.price)}</td>
                    <td className="td-right">{fmt(0)}</td>
                    <td className="td-right">{fmt(taxableValue)}</td>
                    <td className="td-center">
                      {fmt(cgst)} | {fmt(cgstPct)}
                    </td>
                    <td className="td-center">
                      {fmt(sgst)} | {fmt(sgstPct)}
                    </td>
                    <td className="td-right">{fmt(lineTotal)}</td>
                  </tr>
                );
              })}

              {/* ── NET TOTAL row ── 
                  cols: 1(sno) 2(name) 3(hsn) 4(qty) 5(price) 6(discount) = 6 empty
                        7(taxable) 8(cgst) 9(sgst) = 3 cols for label
                        10(total) = amount                                     */}
              <tr className="inv-net">
                <td colSpan={6} style={{ border: "1px solid #bbb", background: "#fff" }} />
                <td
                  colSpan={3}
                  style={{ textAlign: "right", fontSize: 13, letterSpacing: 0.3 }}
                >
                  NET TOTAL (In Value)
                </td>
                <td style={{ textAlign: "right", fontSize: 13 }}>
                  Rs. {fmt(netTotal)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ── reverse charge note ── */}
        <div className="inv-note">
          Whether tax is payable under reverse charge — No
        </div>

      </div>

      <FooterOne />
    </>
  );
};

export default Invoice;